"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hostsPreset = void 0;
exports.hostsPreset = {
    center: {
        protocol: 'https',
        host: 'center.yandex-team.ru',
    },
    staff: {
        protocol: 'https',
        host: 'staff.yandex-team.ru',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaG9zdHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvaG9zdHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxXQUFXLEdBQVU7SUFDOUIsTUFBTSxFQUFFO1FBQ0osUUFBUSxFQUFFLE9BQU87UUFDakIsSUFBSSxFQUFFLHVCQUF1QjtLQUNoQztJQUNELEtBQUssRUFBRTtRQUNILFFBQVEsRUFBRSxPQUFPO1FBQ2pCLElBQUksRUFBRSxzQkFBc0I7S0FDL0I7Q0FDSixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgSG9zdHMgfSBmcm9tICcuJztcblxuZXhwb3J0IGNvbnN0IGhvc3RzUHJlc2V0OiBIb3N0cyA9IHtcbiAgICBjZW50ZXI6IHtcbiAgICAgICAgcHJvdG9jb2w6ICdodHRwcycsXG4gICAgICAgIGhvc3Q6ICdjZW50ZXIueWFuZGV4LXRlYW0ucnUnLFxuICAgIH0sXG4gICAgc3RhZmY6IHtcbiAgICAgICAgcHJvdG9jb2w6ICdodHRwcycsXG4gICAgICAgIGhvc3Q6ICdzdGFmZi55YW5kZXgtdGVhbS5ydScsXG4gICAgfSxcbn07XG4iXX0=